<template :style="{ mixBlendMode: content && content.blendMode ? content.blendMode:'normal' }">
	<div :style="{ mixBlendMode: content && content.blendMode ? content.blendMode:'normal' }">
		<!-- <transition name="slide-fade"> -->
		<vue-draggable-resizable
		class="element-position-lowerthird "
		:style="style"
		:class="className"
		v-if="status ==='preview' && isImage"
		:draggable="status ==='preview' && !item.is_locked"
		:resizable="status ==='preview' && !item.is_locked"
		:x="xElement"
		:y="yElement"
		:w="widthElement"
		:h="heightElement"
		:min-width = "75"
		:min-height = "75"
		:lock-aspect-ratio="isLockRatio"
		@dragstop="onDragstop"
		@resizestop="onResizestop"
		@dragging="onDrag"
		@resizing="onResize"
		:preventActiveBehavior="true"
		:parent="false">
		<div v-if="content && content.isEnableBorder" :style="borderClipPath"></div>
		<div :style="styleWithCroppingOuter" >
			<img
				class="hw-100"
				:id="imageId"
				:style="styleWithCropping"
				scrolling="no"
				ref="image"
			/>
		</div>
		</vue-draggable-resizable>
		<!-- </transition> -->
		<!-- Video Element -->
		<vue-draggable-resizable
		class="element-position-lowerthird "
		:style="style"
		:class="className"
		v-if="status ==='preview' && isVideo"
		:draggable="status ==='preview' && !item.is_locked"
		:lock-aspect-ratio="isLockRatio && !item.is_locked"
		:resizable="status ==='preview' && !item.is_locked"
		:x="content.x"
		:y="content.y"
		:w="content.width"
		:h="content.height"
		:min-width = "75"
		:min-height = "75"
		@dragstop="onDragstop"
		@resizestop="onResizestop"
		@dragging="onDrag"
		@resizing="onResize"
		:preventActiveBehavior="true"
		:parent="false">
		<div v-if="content && content.isEnableBorder" :style="borderClipPath"></div>
		<div :style="styleWithCroppingOuter">
			<div class="element-position"
				:style="styleWithCropping"
				:class="className">
				<div class="text-center w-100 color-white" :style="style"  v-if="!isVideoLoading && isVideo && status ==='preview'">
					<!-- <div class="is-loading loading-iframe"></div> -->
				</div>
				<video
					:id="videoId"
					:loop="isLoop"
					@loadeddata="videoIsReady"
					autoplay
					:width="widthElement"
					:height="heightElement"
					:muted="isPreviewMuted"
					ref="videoPreview">
				</video>
			</div>
		</div>
		</vue-draggable-resizable>
		<div v-if="status ==='live' && isImage" :style="styleOutlineLive">
			<div v-if="content && content.isEnableBorder" :style="borderClipPath"></div>
			<div v-if="status ==='live' && isImage" :style="styleWithCroppingOuter">
					<img
						:id="imageId"
						scrolling="no"
						class="element-position hw-100"
						:style="styleLive"
						:class="className"
						v-if="status ==='live' && isImage"
						ref="image"
					/>
			</div>
		</div>
		<!-- </transition> -->
		<!-- Video Element -->
		<div v-if="status ==='live' && isVideo" :style="styleOutlineLive">
			<div v-if="content && content.isEnableBorder" :style="borderClipPath"></div>
			<div v-if="status ==='live' && isVideo" :style="styleWithCroppingOuter">
				<div class="text-center top-50p w-100 color-white" :style="styleLive"  v-if="!isVideoLoading && isVideo && status ==='live'">
					<!-- <div class="is-loading loading-iframe"></div> -->
				</div>
				<div class="element-position "
					:style="styleLive"
					v-if="status ==='live' && isVideo"
					:class="className">
					<video
						:id="videoId"
						:width="widthElement"
						:height="heightElement"
						@loadeddata="videoIsReady"
						:loop="isLoop"
						autoplay
						:muted="isMuted"
						ref="videoLive">
					</video>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import VueDraggableResizable from 'vue-draggable-resizable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';
import localforage from 'localforage';
import rundownItemsApi from '@/api/rundownItems';
import { duplicateVar, delay } from '@/lib/helper';

export default {
	name: 'ElementMedia',
	components: {
		'vue-draggable-resizable': VueDraggableResizable,
	},
	props: {
		item: {
			type: Object,
		},
		status: {
			type: String,
		},
	},
	data() {
		return {
			isVideoLoading: false,
			localMute: false,
			localMutePreview: true,
			localItem: null,
		};
	},

	sockets: {
		connect() {
			// this.activateSocket();
		},
		items_live_update(items) {
			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				if (this.localItem.id === item.id) {
					const muted = this.content && this.content.muted ? this.content.muted : false;
					this.localMute = muted;
					// const checkLivePlaying = !!(item.is_play_live && this.status === 'preview');
					this.localMutePreview = true;
				}
			}
		},
		force_play_item(data) {
			if (this.localItem.id === data.id) {
				this.localItem = duplicateVar(data);
				this.setVideoTime();
				this.isVideoLoading = false;
				const isVideo = this.localItem.type === 'video';
				this.$nextTick(() => {
					localforage.getItem(`media_${this.content.id}`, (err, value) => {
						if (!err && value) {
							const mediaSource = URL.createObjectURL(value);
							if (isVideo) {
								const videoLive = this.$refs.videoLive;
								const videoPreview = this.$refs.videoPreview;
								if (this.status === 'live' && videoLive) {
									this.$refs.videoLive.src = `${mediaSource}#t=${this.inPoint},${this.outPoint}`;
									this.$refs.videoLive.volume = this.volumeAudio / 100;
									this.$refs.videoLive.play();
								}
								if (this.status === 'preview' && videoPreview) {
									this.$refs.videoPreview.src = `${mediaSource}#t=${this.inPoint},${this.outPoint}`;
									this.$refs.videoPreview.volume = this.volumeAudio / 100;
									this.$refs.videoPreview.play();
								}
							} else {
								// eslint-disable-next-line no-lonely-if
								if (this.$refs.image) {
									this.$refs.image.src = mediaSource;
								}
							}
						} else {
							// eslint-disable-next-line no-lonely-if
							if (isVideo) {
								const videoLive = this.$refs.videoLive;
								const videoPreview = this.$refs.videoPreview;
								if (this.status === 'live' && videoLive) {
									this.$refs.videoLive.src = `${this.content.url}#t=${this.inPoint},${this.outPoint}`;
									this.$refs.videoLive.volume = this.volumeAudio / 100;
									this.$refs.videoLive.play();
								}
								if (this.status === 'preview' && videoPreview) {
									this.$refs.videoPreview.src = `${this.content.url}#t=${this.inPoint},${this.outPoint}`;
									this.$refs.videoPreview.volume = this.volumeAudio / 100;
									this.$refs.videoPreview.play();
								}
							} else {
								// eslint-disable-next-line no-lonely-if
								if (this.$refs.image) {
									this.$refs.image.src = this.content.url;
								}
							}
						}
					});
				});
			}
		},
		item_mute_update(data) {
			const status = data.status;
			const id = data.id;
			if (this.localItem.id === id) {
				const propsMuted = JSON.parse(status);
				this.localMute = propsMuted;
			}
		},
	},
	methods: {
		hasProperty(obj, prop) {
			return Object.prototype.hasOwnProperty.call(obj, prop);
		},
		activateSocket() {
			// this.$socket.client.emit('join', this.room);
		},
		videoIsReady() {
			this.isVideoLoading = true;
		},
		setVideoTime() {
			if (this.status === 'live' && this.$refs.videoLive) {
				this.$refs.videoLive.currentTime = this.playTime;
			}
			if (this.status === 'preview' && this.$refs.videoPreview) {
				this.$refs.videoPreview.currentTime = this.playTime;
			}
		},
		savePosition(x, y) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			const content = duplicateVar(this.content);
			content.x = x;
			content.y = y;
			// eslint-disable-next-line no-restricted-globals
			if (!x || isNaN(x)) {
				content.x = 0;
			} else {
				content.x = x;
			}
			// eslint-disable-next-line no-restricted-globals
			if (!y || isNaN(y)) {
				content.y = 0;
			// eslint-disable-next-line no-restricted-globals
			} else {
				content.y = y;
			}

			content.position = 'custom';
			const params = {
				content: JSON.stringify(content),
				editPreview: 1,
			};
			rundownItemsApi.update(this.localItem.id, params, callback, errorCallback);
		},
		saveSize(x, y, w, h) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			const content = duplicateVar(this.content);
			content.x = x;
			content.y = y;
			content.width = w;
			content.height = h;
			content.position = 'custom';
			// eslint-disable-next-line no-restricted-globals
			if (!w || isNaN(w) || w < 75) {
				content.width = 75;
			} else {
				content.width = w;
			}
			if (!h || (h < 75 && !content.isRatio)) {
				content.height = 75;
			// eslint-disable-next-line no-restricted-globals
			} else if (!h || isNaN(h) || (h < 75 && content.isRatio)) {
				content.height = 42;
			} else {
				content.height = h;
			}
			// eslint-disable-next-line no-restricted-globals
			if (!x || isNaN(x)) {
				content.x = 0;
			} else {
				content.x = x;
			}
			// eslint-disable-next-line no-restricted-globals
			if (!y || isNaN(y)) {
				content.y = 0;
			// eslint-disable-next-line no-restricted-globals
			} else {
				content.y = y;
			}
			const params = {
				content: JSON.stringify(content),
				editPreview: 1,
			};
			rundownItemsApi.update(this.localItem.id, params, callback, errorCallback);
		},
		onDragstop(x, y) {
			this.savePosition(x, y);
		},
		onResizestop(left, top, w, h) {
			this.saveSize(left, top, w, h);
		},
		onDrag() {

		},
		onResize(x, y, width, height) {
			this.content.width = width;
			this.content.height = height;
		},
		onStopVideo() {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			if (this.status === 'live') {
				localStorage.removeItem(`item_duration_${this.localItem.id}`);
				rundownItemsApi.stopLive(this.localItem.id, callback, errorCallback);
			}
			if (this.status === 'preview') {
				rundownItemsApi.stopAll(this.localItem.id, this.status, callback, errorCallback); // stop the lower third automatically
			}
		},
		onCompletePlay(itemId) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			rundownItemsApi.playLive(itemId, callback, errorCallback);
		},
	},
	computed: {
		videoId() {
			return `video-${this.localItem.id}`;
		},
		imageId() {
			return `video-${this.localItem.id}`;
		},
		isLockRatio() {
			return this.content && this.content.isRatio ? this.content.isRatio : false;
		},
		content() {
			return this.localItem.content && this.localItem.content !== ''
				? JSON.parse(this.localItem.content) : {};
		},
		className() {
			return this.content.position ? this.content.position : '';
		},
		xElement() {
			return this.content && this.content.x ? this.content.x : 0;
		},
		yElement() {
			return this.content && this.content.y ? this.content.y : 0;
		},
		widthElement() {
			return this.content && this.content.width ? this.content.width : 0;
		},
		heightElement() {
			return this.content && this.content.height ? this.content.height : 0;
		},
		style() {
			const style = {};
			style.position = 'absolute';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content) {
				if (content.opacity) style.opacity = content.opacity;
			}
			return style;
		},
		borderClipPath() {
			const style = {};
			const content = this.content;
			const thickness = content.borderThickness;
			if (content.width) style.width = `${content.width}px`;
			if (content.height) style.height = `${content.height}px`;
			style.position = 'absolute';
			style.background = content.borderColor || 0;
			// making clipath with absolute position
			// line 410 top and bottom left corner
			// line 411 inside top and bottom left corner
			// line 412 inside top and bottom right corner
			// line 413 quarter left top and bottom
			// line 414 top and bottom corner & inside top and bottom corner
			if (content.isEnableCrop) {
				const top = content.cropTop || 0;
				const bottom = content.cropBottom || 0;
				const left = content.cropLeft || 0;
				const right = content.cropRight || 0;
				style.clipPath = `polygon(${left}px ${top}px, ${left}px ${content.height - bottom}px,
					${thickness + left}px ${content.height - bottom}px, ${thickness + left}px ${thickness + top}px,
					${content.width - (thickness + right)}px ${thickness + top}px, ${content.width - (thickness + right)}px ${content.height - (thickness + bottom)}px,
					${thickness + left}px ${content.height - (thickness + bottom)}px, ${thickness + left}px ${content.height - bottom}px,
					${content.width - right}px ${content.height - bottom}px, ${content.width - right}px ${top}px)`;
			} else {
				style.clipPath = `polygon(0px 0px, 0px ${content.width}px,
					${thickness}px ${content.width}px, ${thickness}px ${thickness}px,
					${content.width - (thickness)}px ${thickness}px, ${content.width - thickness}px ${content.height - thickness}px,
					${thickness}px ${content.height - thickness}px, ${thickness}px ${content.width}px,
					${content.width}px ${content.width}px, ${content.width}px 0px)`;
			}
			return style;
		},
		styleWithCroppingOuter() {
			const style = {};
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			if (content.width) style.width = `${content.width}px`;
			if (content.height) style.height = `${content.height}px`;
			if (content.isEnableBorder) {
				if (content.isEnableCrop) {
					const top = content.cropTop || 0;
					const bottom = content.cropBottom || 0;
					const left = content.cropLeft || 0;
					const right = content.cropRight || 0;
					style.display = 'inline-block';
					style.position = 'relative';
					style.boxSizing = 'border-box';
					style.clipPath = `inset(${top}px ${right}px ${bottom}px ${left}px)`;
				} else {
					style.display = 'inline-block';
					style.position = 'relative';
					style.boxSizing = 'border-box';
					style.clipPath = 'inset(0px 0px 0px 0px)';
				}
			}
			return style;
		},
		styleWithCropping() {
			const style = {};
			style.position = 'absolute';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content && content.blendMode !== 'nomral') style.mixBlendMode = content.blendMode;
			if (content.opacity) style.opacity = content.opacity;
			if (content.isEnableBorder) {
				if (content.isEnableCrop) {
					const thickness = content.borderThickness || 0;
					if (content.width) style.width = `${content.width - (thickness * 2)}px`;
					if (content.height) style.height = `${content.height - (thickness * 2)}px`;
					style.position = 'absolute';
					const top = content.cropTop || 0;
					const bottom = content.cropBottom || 0;
					const left = content.cropLeft || 0;
					const right = content.cropRight || 0;
					style.left = `${thickness}px`;
					style.top = `${thickness}px`;
					style.clipPath = `inset(${top}px ${right}px ${bottom}px ${left}px)`;
				} else {
					const thickness = content.borderThickness || 0;
					if (content.width) style.width = `${content.width - (thickness * 2)}px`;
					if (content.height) style.height = `${content.height - (thickness * 2)}px`;
					style.position = 'absolute';
					style.left = `${thickness}px`;
					style.top = `${thickness}px`;
					style.clipPath = 'inset(0px 0px 0px 0px)';
				}
			} else {
				// eslint-disable-next-line no-lonely-if
				if (content.isEnableCrop) {
					let thickness = 0;
					if (content.isEnableBorder) thickness = content.borderThickness || 0;
					if (content.width) style.width = `${content.width - (thickness * 2)}px`;
					if (content.height) style.height = `${content.height - (thickness * 2)}px`;
					style.position = 'absolute';
					const top = content.cropTop || 0;
					const bottom = content.cropBottom || 0;
					const left = content.cropLeft || 0;
					const right = content.cropRight || 0;
					style.left = `${thickness}px`;
					style.top = `${thickness}px`;
					style.clipPath = `inset(${top}px ${right}px ${bottom}px ${left}px)`;
				} else {
					if (content.width) style.width = `${content.width}px`;
					if (content.height) style.height = `${content.height}px`;
					style.position = 'absolute';
					style.clipPath = 'inset(0px 0px 0px 0px)';
				}
			}
			return style;
		},
		styleOutlineLive() {
			const style = {};
			style.zIndex = this.localItem.layer_index;
			style.position = 'absolute';
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			if (content.width) style.width = `${content.width}px`;
			if (content.height) style.height = `${content.height}px`;
			if (content.y) style.top = `${content.y}px`;
			if (content.x) style.left = `${content.x}px`;
			return style;
		},
		styleLive() {
			const style = {};
			style.position = 'absolute';
			style.border = '0';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content && content.blendMode !== 'nomral') style.mixBlendMode = content.blendMode;
			if (content) {
				if (content.opacity) style.opacity = content.opacity;
				if (content.width) style.width = `${content.width}px`;
				if (content.height) style.height = `${content.height}px`;
				if (content.y) style.top = `${content.y}px`;
				if (content.x) style.left = `${content.x}px`;
				if (content.isEnableCrop) {
					let thickness = 0;
					if (content.isEnableBorder) thickness = content.borderThickness || 0;
					if (content.width) style.width = `${content.width - (thickness * 2)}px`;
					if (content.height) style.height = `${content.height - (thickness * 2)}px`;
					style.position = 'absolute';
					const top = content.cropTop || 0;
					const bottom = content.cropBottom || 0;
					const left = content.cropLeft || 0;
					const right = content.cropRight || 0;
					style.left = `${thickness}px`;
					style.top = `${thickness}px`;
					style.clipPath = `inset(${top}px ${right}px ${bottom}px ${left}px)`;
				} else {
					let thickness = 0;
					if (content.isEnableBorder) thickness = content.borderThickness || 0;
					if (content.width) style.width = `${content.width - (thickness * 2)}px`;
					if (content.height) style.height = `${content.height - (thickness * 2)}px`;
					style.position = 'absolute';
					style.left = `${thickness}px`;
					style.top = `${thickness}px`;
					style.clipPath = 'inset(0px 0px 0px 0px)';
				}
			}
			return style;
		},
		isLoop() {
			return this.content.loop;
		},
		isImage() {
			return this.content && this.content.type === 'image';
		},
		isVideo() {
			return this.content && this.content.type === 'video';
		},
		isPreviewMuted() {
			return this.localMutePreview;
		},
		isMuted() {
			return this.localMute;
		},
		volumeAudio() {
			return this.content && this.content.volumeVideo ? this.content.volumeVideo : 0;
		},
		playTime() {
			return this.localItem && this.localItem.play_time ? this.localItem.play_time : 0;
		},
		inPoint() {
			const hms = this.content.inPoint;// your input string
			const a = hms.split(':'); // split it at the colons
			const seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
			return seconds;
		},
		outPoint() {
			const hms = this.content.outPoint;// your input string
			const a = hms.split(':'); // split it at the colons
			let seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
			const originDuration = Math.floor(this.content.duration);
			if (seconds === parseInt(originDuration)) seconds = this.content.duration;
			return seconds;
		},
	},
	watch: {
		item() {
			if (this.item) {
				this.localItem = this.item;
			}
		},
	},
	created() {
		this.localItem = this.item;
		const muted = this.content && this.content.muted ? this.content.muted : false;
		this.localMute = muted;
		// const checkLivePlaying = !!(this.localItem.is_play_live && this.status === 'preview');
		this.localMutePreview = true;
		// this.activateSocket();
	},
	beforeDestroy() {
		this.localMutePreview = true;
		this.localMute = true;
		delay(() => {
			if (this.status === 'live' && this.$refs.videoLive) {
				this.$refs.videoLive.src = '';
			}
			if (this.status === 'preview' && this.$refs.videoPreview) {
				this.$refs.videoPreview.src = '';
			}
		}, 500);
	},
	mounted() {
		this.setVideoTime();
		this.isVideoLoading = false;
		const isVideo = this.localItem.type === 'video';
		if (this.status === 'live' && isVideo) {
			const detectVideoDone = this.$refs.videoLive;
			const detectVideo = this.$refs.videoLive;
			detectVideoDone.addEventListener('ended', this.onStopVideo, false);

			// play with range
			detectVideo.addEventListener('timeupdate', () => {
				if (detectVideo.currentTime.toFixed(0) === (this.outPoint.toFixed(0))) {
					if (!this.isLoop) {
						const callback = () => {
						};
						const errorCallback = () => {
						};
						localStorage.removeItem(`item_duration_${this.localItem.id}`);
						rundownItemsApi.stopLive(this.item.id, callback, errorCallback);
						if (this.content && this.content.onCompleteItem) {
							this.onCompletePlay(this.content.onCompleteItem);
						}
					} else {
						detectVideo.currentTime = this.inPoint;
					}
				}
			});
		}
		if (this.status === 'preview' && isVideo) {
			const detectVideoDone = this.$refs.videoPreview;
			const detectVideo = this.$refs.videoPreview;
			detectVideoDone.addEventListener('ended', this.onStopVideo, false);
			// play with range
			detectVideo.addEventListener('timeupdate', () => {
				if (detectVideo.currentTime.toFixed(0) === (this.outPoint.toFixed(0))) {
					if (!this.isLoop) {
						const callback = () => {
						};
						const errorCallback = () => {
						};
						rundownItemsApi.stopAll(this.localItem.id, this.status, callback, errorCallback);
					} else {
						detectVideo.currentTime = this.inPoint;
					}
				}
			});
		}
		this.$nextTick(() => {
			localforage.getItem(`media_${this.content.id}`, (err, value) => {
				if (!err && value) {
					const mediaSource = URL.createObjectURL(value);
					if (isVideo) {
						const videoLive = this.$refs.videoLive;
						const videoPreview = this.$refs.videoPreview;
						if (this.status === 'live' && videoLive) {
							this.$refs.videoLive.src = `${mediaSource}#t=${this.inPoint},${this.outPoint}`;
							this.$refs.videoLive.volume = this.volumeAudio / 100;
							this.$refs.videoLive.play();
						}
						if (this.status === 'preview' && videoPreview) {
							this.$refs.videoPreview.src = `${mediaSource}#t=${this.inPoint},${this.outPoint}`;
							this.$refs.videoPreview.volume = this.volumeAudio / 100;
							this.$refs.videoPreview.play();
						}
					} else {
						// eslint-disable-next-line no-lonely-if
						if (this.$refs.image) {
							this.$refs.image.src = mediaSource;
						}
					}
				} else {
					// eslint-disable-next-line no-lonely-if
					if (isVideo) {
						const videoLive = this.$refs.videoLive;
						const videoPreview = this.$refs.videoPreview;
						if (this.status === 'live' && videoLive) {
							this.$refs.videoLive.src = `${this.content.url}#t=${this.inPoint},${this.outPoint}`;
							this.$refs.videoLive.volume = this.volumeAudio / 100;
							this.$refs.videoLive.play();
						}
						if (this.status === 'preview' && videoPreview) {
							this.$refs.videoPreview.src = `${this.content.url}#t=${this.inPoint},${this.outPoint}`;
							this.$refs.videoPreview.volume = this.volumeAudio / 100;
							this.$refs.videoPreview.play();
						}
					} else {
						// eslint-disable-next-line no-lonely-if
						if (this.$refs.image) {
							this.$refs.image.src = this.content.url;
						}
					}
				}
			});
		});
	},
};
</script>
